export const Radius = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '50%',
} as const;

export type RadiusTokenType = keyof typeof Radius;
